import React, { Component } from "react";
import BsyIconBtn from "../BsyIconBtn";
import BsyTableContainer from "../BsyTableContainer";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";

export default class Dlg extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.isFullScreen = false;
    this.element = React.createRef();

    this.isMove = props.isMove || false;
    this.key = props.moveKey || false;

    // ��¼����״̬
    this.isDown = false;
    this.bound = {
      top: -20,
      left: -props.width + 60,
      right: window.innerWidth - 60,
      bottom: window.innerHeight - 60,
    };
    if (this.key) {
      this.start = BsyUtils.Store.get(this.key);
    } else {
      // ��¼��ʼλ��
      this.start = {
        x: 0,
        y: 0,
      };
    }

    this.clickOffset = {
      x: 0,
      y: 0,
    };

    // �϶������е�ƫ��λ��
    this.offset = {
      x: 0,
      y: 0,
    };
  }

  closeAlter = () => {
    this.props.onRemoveRoot();
    if (this.props.onClose) {
      this.props.onClose(this);
    }
  };

  componentDidMount() {
    if (this.isMove && this.element.current && this.start) {
      this.setPos(this.start.x, this.start.y);
    }
  }

  setPos = (posx, posy) => {
    const bound = this.bound;
    const endPos = {
      x:
        posx <= bound.left
          ? bound.left
          : posx >= bound.right
          ? bound.right
          : posx,
      y:
        posy <= bound.top
          ? bound.top
          : posy >= bound.bottom
          ? bound.bottom
          : posy,
    };

    BsyUtils.Store.set(this.key, endPos);
    this.element.current.style.left = `${endPos.x}px`;
    this.element.current.style.top = `${endPos.y}px`;
  };

  _renderContent() {
    if (this.props.onContentCreate) {
      return this.props.onContentCreate(this);
    }
  }

  _renderHeaderOther = () => {
    if (this.props.onHeaderCreate) {
      return this.props.onHeaderCreate(this);
    }
  };

  onCancelClick = () => {
    if (this.props.onCancel) {
      if (this.props.onCancel() === false) {
        return;
      }
    }
    this.closeAlter();
  };

  onCustomClick = () => {
    if (this.props.onCustom) {
      if (this.props.onCustom() === false) {
        return;
      }
    }
    this.closeAlter();
  };

  onOkClick = () => {
    if (this.props.onOk) {
      if (this.props.onOk(this) === false) {
        return;
      }
    }
    this.closeAlter();
  };

  onFullScreen = (event) => {
    this.isFullScreen = !this.isFullScreen;
    if (this.element.current) {
      this.element.current.classList.toggle("full-screen");
      event.target.classList.toggle("icon-bsy-not-full");
    }
  };

  onMouseUp = (event) => {
    this.isDown = false;

    document.removeEventListener("mouseup", this.onMouseUp);
    document.removeEventListener("mousemove", this.onMouseMove);
  };
  onMouseDown = (e) => {
    this.isDown = true;
    document.addEventListener("mouseup", this.onMouseUp);
    document.addEventListener("mousemove", this.onMouseMove);
    const startPos = BsyUtils.elemoffset(this.element.current);
    this.start = {
      x: e.pageX,
      y: e.pageY,
    };

    this.clickOffset = {
      x: e.pageX - startPos.left,
      y: e.pageY - startPos.top,
    };

    // console.log("statr", this.start);
  };
  onMouseMove = (e) => {
    if (!this.isDown) return;
    this.offset = {
      x: e.pageX - this.start.x,
      y: e.pageY - this.start.y,
    };

    const posx = this.start.x + this.offset.x - this.clickOffset.x;
    const posy = this.start.y + this.offset.y - this.clickOffset.y;
    this.setPos(posx, posy);
  };

  render() {
    const {
      title,
      subTitle,
      height,
      width,
      okText,
      cancelText,
      noFooter,
      hasHeader,
      hasFullScreen,
    } = this.props;

    let bodyHeigh = "calc(100% - 120px)";
    let heightOffset = 0;
    if (hasHeader === false) {
    } else {
      heightOffset = 60;
    }
    if (!noFooter) {
      heightOffset += 60;
    }
    bodyHeigh = `calc(100% - ${heightOffset}px)`;

    return (
      <>{this._renderContent()}</>
    );
  }
}

// Dlg.defaultProps = {
//     okText: React.language("ok"),
//     onOk:null,
//     cancelText: React.language("cancel"),
//     onCancel:null,
// }
